import { useState } from 'react';
import { faqs } from '@/mocks/articles';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-100/70">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-label text-secondary-500 tracking-[0.2em] uppercase mb-2">
            FAQ
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-md mx-auto">
            您关心的问题，我们都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg bg-background-50 border border-background-200/50 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="text-sm md:text-base font-label font-medium text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div
                  className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-all duration-300 ${
                    openIndex === index
                      ? 'bg-primary-500 text-background-50 rotate-45'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  <i className="ri-add-line text-sm" />
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FAQPage Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}